import { Box, Heading, HStack, Image, Link, Text, VStack } from "@chakra-ui/react";
import React from "react";
export const Result = (props) => {
    return (React.createElement(VStack, { spacing: 4, width: "100%", alignItems: "flex-start" },
        React.createElement(Box, null,
            React.createElement(Heading, { as: "h3", fontSize: "2xl" },
                React.createElement(Link, { noOfLines: 2, target: "_blank", color: "reaBlue.800", href: props.result.url }, props.result.title)),
            React.createElement(Link, { noOfLines: 1, target: "_blank", color: "gray.500", href: props.result.url }, props.result.url)),
        React.createElement(HStack, { spacing: 4, width: "100%", justifyContent: "flex-start", alignItems: "flex-start" },
            props.result.thumbUrl &&
                React.createElement(Image, { src: props.result.thumbUrl, width: "5rem", height: "5rem", objectFit: "cover", borderRadius: 6 }),
            props.result.description ?
                React.createElement(Text, { noOfLines: 3, flex: 1, dangerouslySetInnerHTML: { __html: props.result.description } })
                :
                    React.createElement(Text, { fontStyle: "italic" }, "Keine Beschreibung"))));
};
